import { useCallback, useEffect, useMemo, useState } from 'react';
import { isLoading } from 'reporting-data/asyncData/AsyncData';
// @ts-expect-error Untyped import
import { reportingApiResolve } from 'reporting-data/v2/reportingApi/resolve';
import { useFetchReportAIAssistantInsightsWithV2 } from 'reporting-enablement/components/singleReportViewer/fullPage/report-ai-assistant-insights/useFetchReportAIAssistantInsights';
import { createInsightReport } from './utils/reportCreationUtils';
export const useFetchColumnInsights = ({
  columnName,
  objectTypeId,
  filterGroups,
  query
}) => {
  const [reportResolve, setReportResolve] = useState(null);
  const report = useMemo(() => {
    return createInsightReport(columnName, objectTypeId, filterGroups, query);
  }, [columnName, objectTypeId, filterGroups, query]);
  const fetchReportResolve = useCallback(async columnReport => {
    const columnReportResolve = await reportingApiResolve(columnReport);
    setReportResolve({
      data: columnReportResolve
    });
  }, [setReportResolve]);
  useEffect(() => {
    if (report) {
      fetchReportResolve(report).catch(e => {
        console.error(`Failure fetching report resolve: ${e}`);
      });
    }
  }, [report, fetchReportResolve]);
  const useFetchReportAIAssistantInsightsHook = useFetchReportAIAssistantInsightsWithV2(report);
  const reportInsightsFetch = useFetchReportAIAssistantInsightsHook({
    report,
    reportResolve,
    numberOfInsights: 1,
    enableSameReportCaching: false
  });
  const isInsightLoading = isLoading(reportInsightsFetch);
  return {
    report,
    reportResolve,
    reportInsightsFetch,
    isInsightLoading
  };
};